import clsx from 'clsx';
import { useFormik } from 'formik';
import moment from 'moment';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { weeksDay } from '../../../data';
import useAppointment from '../../../Features/useAppointment';
import { defineTime } from '../../../Schema';
import Button from '../../UI/Button';
import TimePickerInput from '../../UI/TimePickerInput';
import CommonCard from '../CommonCard';
import classes from './DefineTime.module.css';
const initialValues = {
  startTime: '',
  endTime: ''
};
const DefineTime = () => {
  const { addDoctorTime } = useAppointment();
  const [showClinicTime, setshowClinicTime] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);
  const formik = useFormik({
    initialValues,
    validationSchema: defineTime,
    onSubmit: (values, { resetForm }) => {}
  });
  const {
    values,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
    setFieldTouched,
    
  } = formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  const handleDaysInList = (data) => {
    setSelectedDays((currentState) => {
      if (currentState.includes(data)) {
        return currentState?.filter((day) => day != data);
      }
      return [...currentState, data];
    });
  };
  const handleDoctorTime = () => {
    const startTime = moment(values?.startTime, 'H:mm'); // Parse the first time
    const endTime = moment(values?.endTime, 'H:mm');
    const isBefore = endTime.isBefore(startTime);
    if (selectedDays?.length == 0) {
      return toast.error('Please Select date');
    }
    if (isBefore) {
      return toast.error('End time should be greater than start time');
    }
    const params = {
      days: selectedDays,
      timeFrom: moment(values?.startTime, 'HH:mm').utc().format('HH:mm:ss'),
      TimeTo: moment(values?.endTime, 'HH:mm').utc().format('HH:mm:ss'),

      timeZone: 'Asia/Karachi'
    };

    addDoctorTime(params);
  };
  return (
    <CommonCard className={classes.actionCard}>
      {!showClinicTime && (
        <Button
          label={'Set Clinic Timings'}
          onClick={() => {
            setshowClinicTime((prev) => !prev);
          }}
        />
      )}

      {showClinicTime && (
        <div>
          <h3 className={classes.clinicHeading}>Clinic Time</h3>

          <Row className={classes.controlGrid}>
            <Col sm={6}>
              <TimePickerInput
                setter={(e) => handleChangeWithTouch('startTime', e)}
                value={values?.startTime}
                label={'Sart Time'}
              />
            </Col>
            <Col sm={6}>
              <TimePickerInput
                label={'Close Time'}
                setter={(e) => handleChangeWithTouch('endTime', e)}
                value={values?.endTime}
              />
            </Col>
          </Row>
          <menu className={classes.selectedDayWrapper}>
            {weeksDay?.map((data) => (
              <CommonCard
                onClick={() => {
                  handleDaysInList(data?.value);
                }}
                type={'button'}
                key={data?.id}
                Tag="button"
                className={clsx(classes.weekSelectWrapper, 'transparent-button', {
                  [classes.shine]: selectedDays.includes(data?.value)
                })}>
                <span className={classes.weekName}>{data?.label}</span>
              </CommonCard>
            ))}
          </menu>
          <div className={classes['cta-wrapper']}>
            <Button variants="view" label={'Save'} onClick={handleDoctorTime} />
          </div>
        </div>
      )}
    </CommonCard>
  );
};

export default DefineTime;
